import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

import { MessageBoxLocation } from "features/notifications/components/activation/types";

import { NotificationsTopics } from "../types";
import { NotificationType } from "./consts";

export const makeEventName = (
  event: string,
  notificationType: NotificationType
) => {
  const eventName = `s/notifications/${notificationType}/${event}`;

  if (eventName.length >= 41) {
    throw new Error("GTM max event name length is 40 characters");
  }

  return eventName;
};

export const analyticsLogUserClickedOnNotification = withLogAndSwallowError(
  userClickedOnNotification
);

export const analyticsLogUserClickedOnActivateNotifications =
  withLogAndSwallowError(userClickedOnActivateNotifications);

export const analyticsLogNotificationsPermissionRequestResult =
  withLogAndSwallowError(notificationsPermissionRequestResult);

function userClickedOnNotification(
  source: NotificationsTopics,
  notificationType: NotificationType
) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("click", notificationType),
    payload: { source }
  });
}

function userClickedOnActivateNotifications(source: MessageBoxLocation) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("activate/click", NotificationType.PUSH),
    payload: { source }
  });
}

function notificationsPermissionRequestResult({
  result,
  source
}: {
  result: "allowed" | "denied";
  source: MessageBoxLocation;
}) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName(`permission/${result}`, NotificationType.PUSH),
    payload: { source }
  });
}
